export const GET_WELNESS_ACKNOWLEDGEMENT_REQUEST = "GET_WELNESS_ACKNOWLEDGEMENT_REQUEST";
export const GET_WELNESS_ACKNOWLEDGEMENT_SUCCESS = "GET_WELNESS_ACKNOWLEDGEMENT_SUCCESS";
export const GET_WELNESS_ACKNOWLEDGEMENT_FAILURE = "GET_WELNESS_ACKNOWLEDGEMENT_FAILURE";

export const RESET_WELNESS_ACKNOWLEDGEMENT = "RESET_WELNESS_ACKNOWLEDGEMENT";
